import FormattedMessage from 'I18n/components/FormattedMessage';
import { CTAS, LEARN_MORE_CTAS } from './enums';
import { SERVICE_ACADEMY_URL, SERVICE_SHARED_INBOX_TICKETS_KB_URL, SERVICE_CATEGORIES_APP_MARKETPLACE_URL, HELP_DESK_APP_MARKETPLACE_URL, HELP_DESK_KB_URL } from './urls';
import { jsx as _jsx } from "react/jsx-runtime";
export const getDefaultServiceLearnMoreConfig = appContexts => {
  const {
    authContext
  } = appContexts;
  const hasHelpDeskAccess = authContext.user.scopes.includes('help-desk-access');
  let ctas = [{
    ctaId: CTAS.SERVICE_SLIDESHOW,
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "service.learnMore.ctas.service-sideshow"
    }),
    icon: 'presentation'
  }, {
    ctaId: LEARN_MORE_CTAS.ACADEMY_SERVICE,
    href: SERVICE_ACADEMY_URL,
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "service.learnMore.ctas.academy-customer-service"
    }),
    icon: 'ticket'
  }, {
    ctaId: LEARN_MORE_CTAS.CUSTOMER_SERVICE_CRM,
    href: hasHelpDeskAccess ? HELP_DESK_KB_URL : SERVICE_SHARED_INBOX_TICKETS_KB_URL,
    text: hasHelpDeskAccess ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "service.learnMore.ctas.crm-customer-help-desk"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "service.learnMore.ctas.crm-customer-service"
    }),
    icon: 'inbox',
    external: true
  }, {
    ctaId: LEARN_MORE_CTAS.MARKETPLACE_SERVICE,
    href: hasHelpDeskAccess ? HELP_DESK_APP_MARKETPLACE_URL : SERVICE_CATEGORIES_APP_MARKETPLACE_URL,
    external: true,
    text: hasHelpDeskAccess ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "service.learnMore.ctas.app-marketplace-help-desk"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "service.learnMore.ctas.app-marketplace-service"
    }),
    icon: 'marketplace'
  }];

  // temporary: filter out academy lesson for help desk users until new lesson is created
  // project tracked here https://airtable.com/app5tjngOBcV2g5Cp/shrKvbvuLYhztOBtg/tbl6F1vVf1KXdJ4Ws
  if (hasHelpDeskAccess) {
    ctas = ctas.filter(cta => cta.ctaId !== LEARN_MORE_CTAS.ACADEMY_SERVICE);
  }
  return {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "service.learnMore.description"
    }),
    ctas
  };
};